import React from 'react';
import { Grid } from '@chakra-ui/react';
import { GrDocumentTime } from 'react-icons/gr';
import { FaFileContract, FaWhatsapp } from 'react-icons/fa6';
import { MdHub, MdPix, MdUpgrade } from 'react-icons/md';
import { FaShieldAlt, FaWifi } from 'react-icons/fa';
import { BoxLink } from './BoxLink';
import { useTheme } from '@/contexts/ThemeProvider';

interface CustomerCentralBoxesProps {
  colors: { primaryColor: string };
  slug?: string;
  integrationId?: string;
  lastContrato: any;
  hasSegundaVia: boolean;
  isSegundaViaLoading?: boolean;
  hasPix: boolean;
  isPixLoading?: boolean;
  isFaturaPaga?: boolean;
  onPixClick: () => void;
  onSegundaViaClick: () => void;
  onContratosClick: () => void;
  showConexoes?: boolean;
  onConexoesClick: () => void;
  onUpgradeClick: () => void;
  onWhatsAppClick: () => void;
  onDesbloqueioClick: () => void;
  onRouterCredentialsClick: () => void;
}

export function CustomerCentralBoxes({
  colors,
  slug,
  integrationId,
  lastContrato,
  hasSegundaVia,
  isSegundaViaLoading,
  hasPix,
  isPixLoading,
  isFaturaPaga,
  onPixClick,
  onSegundaViaClick,
  onContratosClick,
  showConexoes,
  onConexoesClick,
  onUpgradeClick,
  onWhatsAppClick,
  onDesbloqueioClick,
  onRouterCredentialsClick,
  
}: CustomerCentralBoxesProps) {
  const { id: agreementId } = useTheme();
  const boxes: React.ReactNode[] = [];

  boxes.push(
    <BoxLink
      key="segunda-via"
      onPress={onSegundaViaClick}
      color={colors.primaryColor}
      name="Segunda Via"
      icon={GrDocumentTime}
      isLoading={isSegundaViaLoading}
    />
  );

  if (hasPix) {
    boxes.push(
      <BoxLink
        key="pix"
        onPress={onPixClick}
        color={colors.primaryColor}
        name="Pagar com Pix"
        icon={MdPix}
        isLoading={isPixLoading}
        isInactive={isFaturaPaga}
      />
    );
  }

  if (lastContrato) {

    if (slug !== 'newoesteconnect') {
      boxes.push(
        <BoxLink
          key="contratos"
          onPress={onContratosClick}
          color={colors.primaryColor}
          name="Contratos"
          icon={FaFileContract}
        />
      );
    }
    if (showConexoes) {
      boxes.push(
        <BoxLink
          key="conexoes"
          onPress={onConexoesClick}
          color={colors.primaryColor}
          name="Conexões"
          icon={MdHub}
        />
      );
    }
    // Convênio 3251 não oferece upgrade de planos
    if (agreementId !== 3251) boxes.push(
      <BoxLink
        key="upgrade"
        onPress={() => {
          if ((lastContrato as any)?.numero_contrato ?? lastContrato?.codigo_contrato) {
            onUpgradeClick();
          }
        }}
        color={colors.primaryColor}
        name="Upgrade de Planos"
        icon={MdUpgrade}
      />
    );
  }

  boxes.push(
    <BoxLink
      key="whatsapp"
      onPress={onWhatsAppClick}
      color={colors.primaryColor}
      name="Entrar em contato"
      icon={FaWhatsapp}
    />
  );

  if (integrationId === 'ixc' || integrationId === 'hubsoft' || integrationId === 'mk') {
    boxes.push(
      <BoxLink
        key="desbloqueio"
        onPress={onDesbloqueioClick}
        color={colors.primaryColor}
        name="Desbloqueio de Confiança"
        icon={FaShieldAlt}
      />
    );
  }

  if (lastContrato) {
    if (integrationId === 'hubsoft') {
      boxes.push(
        <BoxLink
          key="router-credentials"
          onPress={onRouterCredentialsClick}
          color={colors.primaryColor}
          name="Troca de Credenciais do Roteador"
          icon={FaWifi}
        />
      );
    }
  }

  return (
    <Grid templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }} gap={4} width="100%">
      {boxes}
    </Grid>
  );
}
